import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "fixed w-full",
  style: {"z-index":"1030"}
}
const _hoisted_2 = { class: "relative z-10 bg-primary-800 h-24" }
const _hoisted_3 = { class: "mx-auto max-w-dashboard" }
const _hoisted_4 = {
  style: {"height":"100px"},
  class: "flex items-center h-24"
}
const _hoisted_5 = { class: "flex items-center h-full" }
const _hoisted_6 = {
  key: 0,
  class: "flex-shrink-0 h-full"
}
const _hoisted_7 = { class: "h-full w-full" }
const _hoisted_8 = { class: "flex justify-end items-center divide-x divide-primary-700 h-full" }
const _hoisted_9 = {
  key: 0,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_10 = {
  key: 1,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_11 = {
  key: 2,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_12 = {
  key: 3,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_13 = {
  key: 4,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_14 = {
  key: 5,
  class: "px-4 xl:px-6 h-full grid content-center"
}
const _hoisted_15 = { class: "px-4 xl:px-6 h-full grid content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationPicker = _resolveComponent("LocationPicker")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_Notes = _resolveComponent("Notes")!
  const _component_Assignments = _resolveComponent("Assignments")!
  const _component_ActionsMenu = _resolveComponent("ActionsMenu")!
  const _component_CreateEventAction = _resolveComponent("CreateEventAction")!
  const _component_GearMenu = _resolveComponent("GearMenu")!
  const _component_ProfileMenu = _resolveComponent("ProfileMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.hasActiveDirectory)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_LocationPicker)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.hasActiveDirectory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_Notifications)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasRealTimeModuleEnabled && _ctx.hasActiveDirectory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_Notes)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasAssignmentsMobuleEnabled && _ctx.hasActiveDirectory && !_ctx.hasRealtimeOnlyModule)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_Assignments)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasActiveDirectory && !_ctx.hasRealtimeOnlyModule)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_ActionsMenu)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasActiveDirectory && !_ctx.hasRealtimeOnlyModule)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_CreateEventAction, { class: "my-auto" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canManageDirectory || _ctx.cookieBotConfigured)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_GearMenu)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ProfileMenu)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}